import classNames from 'classnames';
var FavoriteHeader = function (_a) {
    var text = _a.text, children = _a.children, className = _a.className;
    return (<div className={classNames(className, 'text-brand-01 text-lg font-medium border-gray-200 border-b pb-4')}>
      {children}
      <span>{text}</span>
    </div>);
};
export default FavoriteHeader;
